export const TopicID = `chat.messages`;
export const TopicNameRegExp = new RegExp('/DEPRECATED/');
export const SubscriptionParamsSchema = { type: "null" };
